import { OTA_VehReservation } from "./ota_vehreservation.model";

export class OTA_VehRetResRSCore {
    public vehReservation = new OTA_VehReservation();
}